module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.65a54719.jpg";